// extracted by mini-css-extract-plugin
export default {"customFooter":"Footer_customFooter__Al_9","footerContent":"Footer_footerContent_wsMqB","spinAround":"Footer_spinAround_pK4Kg"};